import { PushNotificationEventName } from "../../enum/push-notifications/push-notification-events.enum";
import { PushNotification } from './push-notification.model';


export class PushNotificationEvent {

    type: PushNotificationEventName;
    notification: PushNotification;
    error: any;

    constructor(type, notification, error?) {
        this.type = type;
        this.notification = notification;
        this.error = error;
    }

}